const dominio = process.env.VUE_APP_API;
const server = process.env.VUE_APP_API_SERVER_BACKEND;

// URL del PANEL. De aquí cuelgan los enlaces y QR de check-in que se le dan al
// huésped. Estaba escrita a mano como producción en cada sitio, así que en beta
// se generaban accesos que llevaban a go.wacheckin.com. El respaldo mantiene el
// comportamiento de producción si la variable no estuviera definida.
const app = process.env.VUE_APP_URL || "https://go.wacheckin.com";

export { dominio, server, app };
